'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoLocation = function IoLocation(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19.8 5c5.2 0 9.4 4.2 9.4 9.4 0 9-9.4 20.6-9.4 20.6s-9.3-11.6-9.3-20.6c0-5.2 4.1-9.4 9.3-9.4z m0 13.9c2.4 0 4.5-1.9 4.5-4.4s-2.1-4.4-4.5-4.4-4.4 2-4.4 4.4 2 4.4 4.4 4.4z' })
        )
    );
};

exports.default = IoLocation;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/location.js
// module id = 2821
// module chunks = 168707334958949